import React, { useContext, useEffect } from "react";
import { Routes, Route, Navigate, HashRouter } from "react-router-dom";
import AppRoute from "./AppRoute";
import { ThemeContext } from "../Components/context/theme.context";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import DeleteRoute from "./DeleteRoute";
const MainRoutes = () => {
  const { mode } = useContext(ThemeContext);
  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode,
        },
      }),
    [mode]
  );
  useEffect(() => {
    // localStorage.setItem("5ktheme", mode);
  }, [mode]);
  return (
    <div>
      <ThemeProvider theme={theme}>
        <HashRouter>
          <Routes>
            <Route path="*" element={<Navigate to="app/" />} />
            {/* <Route path="auth/*" element={<AuthRoutes />} /> */}
            <Route path="app/*" element={<AppRoute />} />
            <Route path="delete/*" element={<DeleteRoute />} />
          </Routes>
          <Routes></Routes>
        </HashRouter>
      </ThemeProvider>
    </div>
  );
};
export default MainRoutes;
